import { apiConnector } from '../apiConnector';
import { forecastProductsEndpoints, specialProducts } from '../apis';
import { toast } from 'react-hot-toast';

const { GET_ALL_SPECIAL_PRODUCTS_NAMES } = specialProducts;

export const fetchSpecialProductsNames = async () => {
  try {
    const response = await apiConnector('GET', GET_ALL_SPECIAL_PRODUCTS_NAMES);
    console.log(response);

    // Ensure response.data is a valid array before proceeding
    if (!Array.isArray(response.data) || response.data.length === 0) {
      throw new Error('Could Not Fetch Special Forecast Products');
    }

    // toast.success('Products fetched successfully!');
    return response.data;
  } catch (error) {
    toast.error('Failed to load special forecast products');
    console.error('API Error:', error);
    throw error;
  }
};

// export const fetchSpecialProductsModels = async () => {
//   const toastId = toast.loading('Loading special forecast products...');
//   let result = [];

//   try {
//     const response = await apiConnector('GET', GET_ALL_SPECIAL_PRODUCTS);

//     if (!response?.data?.success) {
//       throw new Error('Could Not Fetch Special Forecast Products');
//     }
//     result = response?.data;
//   } catch (error) {
//     console.error('Error fetching special forecast products:', error);
//     toast.error('Failed to load special forecast products');
//   } finally {
//     toast.dismiss(toastId);
//   }

//   return result;
// };

// export const fetchSpecialProductById = async (productId) => {
//   const toastId = toast.loading('Loading special forecast product...');
//   let result = null;

//   try {
//     const response = await apiConnector('GET', `${GET_SPECIAL_PRODUCT}`);

//     if (!response?.data?.success) {
//       throw new Error('Could not fetch the special forecast product');
//     }
//     result = response?.data?.forecastProduct;
//   } catch (error) {
//     console.error('Error fetching special forecast product:', error);
//     toast.error('Failed to load special forecast product');
//   } finally {
//     toast.dismiss(toastId);
//   }

//   return result;
// };

// export const fetchRegionalWeather = async (date, utc, forecastHour) => {
//   const toastId = toast.loading('Loading regional weather forecast...');
//   let result = [];

//   try {
//     const params = new URLSearchParams();
//     if (date) params.append('date', date);
//     if (utc) params.append('utc', utc);
//     if (forecastHour === 0 || forecastHour)
//       params.append('forecast_hour', forecastHour);

//     const url = `${GET_REGIONAL_WEATHER}?${params.toString()}`;

//     // API request
//     const response = await apiConnector('GET', url);

//     if (!response?.data?.success) {
//       throw new Error('Could not fetch regional weather forecast');
//     }

//     // Extract the products (image URLs) from the response
//     result = response?.data?.products || [];
//   } catch (error) {
//     console.error('Error fetching regional weather forecast:', error);
//     toast.error('Failed to load regional weather forecast');
//   } finally {
//     toast.dismiss(toastId);
//   }

//   return result;
// };
